/* eslint-disable camelcase */

type Locale = 'en' | 'es';

type Phrase = (l: Locale, months: number) => string;

export const i18n_12_months_for_price_of_x__capital_months: Phrase = (locale, months) => {
  const en = `12 Months for the price of ${months}`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `12 meses por el precio de ${months}.`,
  };
  return phrases[locale] || en;
};
